var _ = require('lodash');
import {randomValue} from '../utils';

/**
 * An instantiable Artist API logic. The methods on this object are called by
 * generated user code. As they are called, they insert commands into this.log.
 * NOTE: this.log is also modified in some cases externally (both accessed and
 * I think cleared).
 */
var ArtistAPI = function() {
  this.log = [];
};

module.exports = ArtistAPI;

ArtistAPI.prototype.random = function(values) {
  return randomValue(values);
};

ArtistAPI.prototype.drawCircle = function(size, id) {
  for (var i = 0; i < 36; i++) {
    this.moveForward(size, id);
    this.turnRight(10, id);
  }
};

ArtistAPI.prototype.drawSnowflake = function(type, id) {
  var i, j, k;

  // mirors Blockly.JavaScript.colour_random.
  var random_colour = function() {
    var colors = Blockly.FieldColour.COLOURS;
    return colors[Math.floor(Math.random() * colors.length)];
  };

  if (type === 'random') {
    type = _.sample([
      'fractal',
      'flower',
      'spiral',
      'line',
      'parallelogram',
      'square'
    ]);
  }

  switch (type) {
    case 'fractal':
      for (i = 0; i < 8; i++) {
        this.jumpForward(45, id);
        this.turnLeft(45, id);
        for (j = 0; j < 3; j++) {
          for (k = 0; k < 3; k++) {
            this.moveForward(15, id);
            this.moveBackward(15, id);
            this.turnRight(45, id);
          }
          this.turnLeft(90, id);
          this.moveBackward(15, id);
          this.turnLeft(45, id);
        }
        this.turnRight(90, id);
      }
      break;

    case 'flower':
      for (i = 0; i < 5; i++) {
        this.drawCircle(2, id);
        this.drawCircle(4, id);
        this.turnRight(72, id);
      }
      break;

    case 'spiral':
      for (i = 0; i < 20; i++) {
        this.drawCircle(3, id);
        this.moveForward(20, id);
        this.turnRight(18, id);
      }
      break;

    case 'line':
      for (i = 0; i < 90; i++) {
        this.penColour(random_colour());
        this.moveForward(50, id);
        this.moveBackward(50, id);
        this.turnRight(4, id);
      }
      this.penColour('#FFFFFF', id);
      break;

    case 'parallelogram':
      for (i = 0; i < 10; i++) {
        for (j = 0; j < 2; j++) {
          this.moveForward(50, id);
          this.turnRight(60, id);
          this.moveForward(50, id);
          this.turnRight(120, id);
        }
        this.turnRight(36, id);
      }
      break;

    case 'square':
      for (i = 0; i < 10; i++) {
        for (j = 0; j < 4; j++) {
          this.moveForward(50, id);
          this.turnRight(90, id);
        }
        this.turnRight(36, id);
      }
      break;
  }
};

ArtistAPI.prototype.moveForward = function(distance, id) {
  this.log.push(['FD', distance, id]);
};

ArtistAPI.prototype.moveBackward = function(distance, id) {
  this.log.push(['FD', -distance, id]);
};

ArtistAPI.prototype.moveUp = function(distance, id) {
  this.log.push(['MV', distance, 0, id]);
};

ArtistAPI.prototype.moveDown = function(distance, id) {
  this.log.push(['MV', distance, 180, id]);
};

ArtistAPI.prototype.moveLeft = function(distance, id) {
  this.log.push(['MV', distance, 270, id]);
};

ArtistAPI.prototype.moveRight = function(distance, id) {
  this.log.push(['MV', distance, 90, id]);
};

ArtistAPI.prototype.jumpTo = function(position, id) {
  this.log.push(['JT', position, id]);
};

ArtistAPI.prototype.jumpToXY = function(x, y, id) {
  this.log.push(['JT', [x, y], id]);
};

ArtistAPI.prototype.moveUpRight = function(distance, id) {
  this.log.push(['MD', distance, 45, id]);
};

ArtistAPI.prototype.moveDownRight = function(distance, id) {
  this.log.push(['MD', distance, 135, id]);
};

ArtistAPI.prototype.moveDownLeft = function(distance, id) {
  this.log.push(['MD', distance, 225, id]);
};

ArtistAPI.prototype.moveUpLeft = function(distance, id) {
  this.log.push(['MD', distance, 315, id]);
};

ArtistAPI.prototype.jumpUp = function(distance, id) {
  this.log.push(['JD', distance, 0, id]);
};

ArtistAPI.prototype.jumpDown = function(distance, id) {
  this.log.push(['JD', distance, 180, id]);
};

ArtistAPI.prototype.jumpLeft = function(distance, id) {
  this.log.push(['JD', distance, 270, id]);
};

ArtistAPI.prototype.jumpRight = function(distance, id) {
  this.log.push(['JD', distance, 90, id]);
};

ArtistAPI.prototype.jumpUpRight = function(distance, id) {
  this.log.push(['JD', distance, 45, id]);
};

ArtistAPI.prototype.jumpDownRight = function(distance, id) {
  this.log.push(['JD', distance, 135, id]);
};

ArtistAPI.prototype.jumpDownLeft = function(distance, id) {
  this.log.push(['JD', distance, 225, id]);
};

ArtistAPI.prototype.jumpUpLeft = function(distance, id) {
  this.log.push(['JD', distance, 315, id]);
};

ArtistAPI.prototype.jumpForward = function(distance, id) {
  this.log.push(['JF', distance, id]);
};

ArtistAPI.prototype.jumpBackward = function(distance, id) {
  this.log.push(['JF', -distance, id]);
};

ArtistAPI.prototype.turnRight = function(angle, id) {
  this.log.push(['RT', angle, id]);
};

ArtistAPI.prototype.turnLeft = function(angle, id) {
  this.log.push(['RT', -angle, id]);
};

ArtistAPI.prototype.pointTo = function(angle, id) {
  this.log.push(['PT', angle, id]);
};

ArtistAPI.prototype.globalAlpha = function(alpha, id) {
  this.log.push(['GA', alpha, id]);
};

ArtistAPI.prototype.penUp = function(id) {
  this.log.push(['PU', id]);
};

ArtistAPI.prototype.penDown = function(id) {
  this.log.push(['PD', id]);
};

ArtistAPI.prototype.penWidth = function(width, id) {
  this.log.push(['PW', Math.max(width, 0), id]);
};

ArtistAPI.prototype.penColour = function(colour, id) {
  this.log.push(['PC', colour, id]);
};

ArtistAPI.prototype.penPattern = function(pattern, id) {
  this.log.push(['PS', pattern, id]);
};

ArtistAPI.prototype.hideTurtle = function(id) {
  this.log.push(['HT', id]);
};

ArtistAPI.prototype.showTurtle = function(id) {
  this.log.push(['ST', id]);
};

ArtistAPI.prototype.drawShape = function(sticker, size, id) {
  this.log.push(['shape', sticker, size, id]);
};

ArtistAPI.prototype.drawSticker = function(sticker, size, id) {
  this.log.push(['sticker', sticker, size, id]);
};

ArtistAPI.prototype.setArtist = function(artist, id) {
  this.log.push(['setArtist', artist, id]);
};
